import React, { useState , useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

// Icons
import AddCall from '@mui/icons-material/AddCall';
import AccountCircle from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';

import AuthContext, { AuthProvider } from '../context/AuthContext'



const CheckPhoneForMediaUpload = () => {
  let { logOutUser, user } = useContext(AuthContext)
  let navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [anchorEl, setAnchorEl] = useState(null);
  

  

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // const handleLogout = () => {
  //   // Implement your logout logic here
  //   sessionStorage.removeItem('userPhone');
  //   setSnackbarMessage('Logged out successfully!');
  //   setSnackbarSeverity('success');
  //   setOpen(true);
  //   handleCloseMenu();
  //   setTimeout(() => {
  //     navigate('/login');
  //   }, 1500);
  // };

  const handleGoToDashboard = () => {
    navigate('/');
    handleCloseMenu();
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const checkNumber = async () => {
    setLoading(true);
    if (phoneNumber) {
      try {
        // const api_link = 'http://127.0.0.1:8000/check-phone-for-media-upload/';
        const api_link = 'https://api.mba-gris.stgafrica.org/check-phone-for-media-upload/'
        const response = await fetch(api_link, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone_number: phoneNumber, data_entry_officer:user?.username || '' }),
        });

        if (response.ok) {
          sessionStorage.setItem('userPhone', phoneNumber);
          setSnackbarMessage('Huraayy! You scouted this innovator.');
          setSnackbarSeverity('success');
          setOpen(true);
          setTimeout(() => {
            navigate('/add-innovator-multimedia');
          }, 2000);
        } else if (response.status === 401) {
          setSnackbarMessage("You didn't scout for this innovator.");
          setSnackbarSeverity('warning');
          setOpen(true);
        }
      } catch (error) {
        setSnackbarMessage("An error occurred. Contact Admin for assistance.");
        setSnackbarSeverity('error');
        setOpen(true);
      } finally {
        setLoading(false);
      }
    } else {
      setSnackbarMessage("Phone number cannot be empty.");
      setSnackbarSeverity('info');
      setOpen(true);
      setLoading(false);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Top Navigation Bar */}
      <AppBar position="static" sx={{ backgroundColor: 'blue' }}> {/* Changed to a darker green hex code */}
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Innovator Portal
          </Typography>
          <Button
            color="inherit" // Keeps text white for contrast
            startIcon={<DashboardIcon />}
            onClick={handleGoToDashboard}
            sx={{ display: { xs: 'none', sm: 'flex' } }}
          >
            Dashboard
          </Button>
          <IconButton
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit" // Keeps icon white for contrast
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={handleGoToDashboard} sx={{ display: { sm: 'none' } }}>
              <DashboardIcon sx={{ mr: 1 }} /> Dashboard
            </MenuItem>
            <MenuItem onClick={logOutUser}>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Main Content - Innovator Phone Form */}
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          '& > :not(style)': { m: 1, width: { xs: '80%', sm: '40%', md: '30ch' } },
          minHeight: 'calc(100vh - 64px)',
          pt: 2,
        }}
        noValidate
        autoComplete="off"
      >
        <img src={require("../assets/images/mba-logo.png")} alt="Logo" style={{ width: '100px', height: 'auto' }} />

        <div style={{ textAlign: 'center' }}>
          <h4>Innovators Mulitmedia Database</h4>
        </div>
        <div>
          <TextField
            style={{ width: '100%' }}
            id="outlined-basic"
            label="Innovator's phone number"
            variant="outlined"
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          <br /><br />
          <Button
            onClick={checkNumber}
            variant="contained"
            size="large"
            style={{ padding: '10px', backgroundColor: 'blue', width: '100%' }}
            endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <AddCall />}
            disabled={loading}
          >
            {loading ? 'Checking...' : 'Check Number'}
          </Button>
        </div>
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} variant="filled" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CheckPhoneForMediaUpload;